/**
 * Toplu hedef atamanın adımları ve adım kuralları (mobil
 * components/groups-manage/bulkGoals/bulkSteps.ts ile aynı).
 */
export const BULK_STEPS = ["goals", "members", "preview", "result"];

/** Sunucudaki sınır (bulkAssign.service MAX_MEMBERS). */
export const MAX_BULK_MEMBERS = 500;

/** Sunucudaki sınır (goalItems.js MAX_GOAL_ITEMS). */
export const MAX_BULK_GOALS = 20;

/** Adım tamam mı: liste dolu (en çok 20), 1 ile 500 üye seçili, önizleme gelmiş. */
export function canAdvance(step, { goalCount = 0, selectedCount = 0, previewReady = false } = {}) {
  if (step === "goals") return goalCount > 0 && goalCount <= MAX_BULK_GOALS;
  if (step === "members") return selectedCount > 0 && selectedCount <= MAX_BULK_MEMBERS;
  if (step === "preview") return Boolean(previewReady);
  return true;
}

/**
 * Sunucudan kesin cevap yok: ağ hatası, zaman aşımı ya da ağ geçidi (502,
 * 504) cevabı. Sunucu yazmaya devam ediyor olabilir; ikinci kez gönderilmez.
 * baseQuery cevapsız isteklerde status'u "FETCH_ERROR" yapar.
 */
export function noServerResponse(error) {
  const status = error?.status;
  return status === undefined || status === "FETCH_ERROR" || [0, 408, 502, 504].includes(status);
}
